import http from "@/http/http-common";
const resource = "/api/frontend";
export default {
    getAmberHillSetting() {
        return http.get(`${resource}/settings`)
            .then(response => {
                return response.data;
            })
    }
}